<script setup>
defineProps({
  width: {
    type: Number,
    default: 28,
  },
  height: {
    type: Number,
    default: 29,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8.5C0.5 4.35786 3.85786 1 8 1H20C24.1421 1 27.5 4.35786 27.5 8.5V20.5C27.5 24.6421 24.1421 28 20 28H8C3.85786 28 0.5 24.6421 0.5 20.5V8.5Z"
      stroke="#FFDFD7"
    />
    <path
      d="M18.5179 11.7496H9.48221C9.26536 11.7496 9.08936 11.5736 9.08936 11.3567C9.08936 11.1399 9.26536 10.9639 9.48221 10.9639H18.5179C18.7348 10.9639 18.9108 11.1399 18.9108 11.3567C18.9108 11.5736 18.7348 11.7496 18.5179 11.7496Z"
      fill="#ED4F38"
    />
    <path
      d="M16.4285 19.9996H11.5716C11.3547 19.9996 11.1787 19.8236 11.1787 19.6067C11.1787 19.3899 11.3547 19.2139 11.5716 19.2139H16.4287C16.6455 19.2139 16.8215 19.3899 16.8215 19.6067C16.8215 19.8236 16.6455 19.9996 16.4285 19.9996Z"
      fill="#ED4F38"
    />
    <path
      d="M16.4285 19.9998C16.2116 19.9998 16.0356 19.8238 16.0356 19.607C16.0356 19.3901 16.2116 19.2141 16.4285 19.2141C16.632 19.2141 16.8003 19.0613 16.8194 18.8586C16.8398 18.6425 17.0306 18.4848 17.2478 18.5046C17.4639 18.5252 17.6222 18.717 17.6018 18.933C17.5438 19.5412 17.0396 19.9998 16.4285 19.9998Z"
      fill="#ED4F38"
    />
    <path
      d="M17.2111 19.2885C17.1988 19.2885 17.1862 19.2879 17.1736 19.2867C16.9575 19.2661 16.7992 19.0743 16.8196 18.8583L17.5376 11.3195C17.558 11.1035 17.7491 10.9455 17.966 10.9656C18.1821 10.9862 18.3404 11.1779 18.32 11.394L17.602 18.9327C17.5824 19.1362 17.4113 19.2885 17.2111 19.2885Z"
      fill="#ED4F38"
    />
    <path
      d="M11.5715 19.9999C10.9606 19.9999 10.4562 19.5413 10.3983 18.9331C10.3778 18.7171 10.5362 18.5254 10.7522 18.5047C10.9708 18.4841 11.16 18.6428 11.1806 18.8587C11.1999 19.0614 11.368 19.2142 11.5715 19.2142C11.7884 19.2142 11.9644 19.3902 11.9644 19.6071C11.9644 19.8239 11.7884 19.9999 11.5715 19.9999Z"
      fill="#ED4F38"
    />
    <path
      d="M10.7891 19.2885C10.5888 19.2885 10.4177 19.1363 10.3984 18.9328L9.68049 11.394C9.66006 11.178 9.81838 10.9862 10.0344 10.9656C10.2497 10.9454 10.4422 11.1035 10.4629 11.3196L11.1808 18.8583C11.2012 19.0744 11.0429 19.2661 10.8268 19.2867C10.8141 19.2879 10.8017 19.2885 10.7891 19.2885Z"
      fill="#ED4F38"
    />
    <path
      d="M15.1787 9.78571H12.8216C12.6047 9.78571 12.4287 9.60971 12.4287 9.39286C12.4287 9.176 12.6047 9 12.8216 9H15.1787C15.3956 9 15.5716 9.176 15.5716 9.39286C15.5716 9.60971 15.3956 9.78571 15.1787 9.78571Z"
      fill="#ED4F38"
    />
    <path
      d="M15.9642 10.5714C15.7474 10.5714 15.5714 10.3954 15.5714 10.1786C15.5714 9.96191 15.3952 9.78571 15.1785 9.78571C14.9616 9.78571 14.7856 9.60971 14.7856 9.39286C14.7856 9.176 14.9616 9 15.1785 9C15.8285 9 16.3571 9.52859 16.3571 10.1786C16.3571 10.3954 16.1811 10.5714 15.9642 10.5714Z"
      fill="#ED4F38"
    />
    <path
      d="M15.9641 11.7504C15.7473 11.7504 15.5713 11.5744 15.5713 11.3576V10.179C15.5713 9.96213 15.7473 9.78613 15.9641 9.78613C16.181 9.78613 16.357 9.96213 16.357 10.179V11.3576C16.357 11.5744 16.181 11.7504 15.9641 11.7504Z"
      fill="#ED4F38"
    />
    <path
      d="M12.0359 10.5714C11.8191 10.5714 11.6431 10.3954 11.6431 10.1786C11.6431 9.52859 12.1717 9 12.8216 9C13.0385 9 13.2145 9.176 13.2145 9.39286C13.2145 9.60971 13.0385 9.78571 12.8216 9.78571C12.605 9.78571 12.4288 9.96191 12.4288 10.1786C12.4288 10.3954 12.2528 10.5714 12.0359 10.5714Z"
      fill="#ED4F38"
    />
    <path
      d="M12.0359 11.7504C11.8191 11.7504 11.6431 11.5744 11.6431 11.3576V10.179C11.6431 9.96213 11.8191 9.78613 12.0359 9.78613C12.2528 9.78613 12.4288 9.96213 12.4288 10.179V11.3576C12.4288 11.5744 12.2528 11.7504 12.0359 11.7504Z"
      fill="#ED4F38"
    />
    <path
      d="M14.0003 17.5449C13.7834 17.5449 13.6074 17.3689 13.6074 17.1521V13.8128C13.6074 13.5959 13.7834 13.4199 14.0003 13.4199C14.2171 13.4199 14.3931 13.5959 14.3931 13.8128V17.1521C14.3931 17.3689 14.2171 17.5449 14.0003 17.5449Z"
      fill="#ED4F38"
    />
    <path
      d="M15.6892 17.5443C15.6829 17.5443 15.6766 17.5443 15.6701 17.5439C15.4533 17.5337 15.2861 17.3496 15.2963 17.1328L15.4553 13.7935C15.4655 13.5766 15.6503 13.4046 15.8664 13.4199C16.0832 13.4301 16.2504 13.6142 16.2402 13.831L16.0813 17.1703C16.0713 17.3805 15.8974 17.5443 15.6892 17.5443Z"
      fill="#ED4F38"
    />
    <path
      d="M12.3112 17.5445C12.1028 17.5445 11.9291 17.3807 11.9191 17.1703L11.7602 13.831C11.75 13.6142 11.9174 13.4301 12.134 13.4199C12.3487 13.4046 12.5347 13.5766 12.5451 13.7935L12.704 17.1328C12.7143 17.3496 12.5469 17.5337 12.3302 17.5439C12.324 17.5445 12.3177 17.5445 12.3112 17.5445Z"
      fill="#ED4F38"
    />
  </svg>
</template>
